import { get } from 'helpers/apiHelpers';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DietDetails from 'views/Orders/Diets/Details/DietDetails.container';

import NoDietsCalendar from './NoDietsCalendar';

type CalendarProps = {
  userId: string;
};

const Calendar = ({ userId }: CalendarProps) => {
  const [dietId, setDietId] = useState<string>('');

  useEffect(() => {
    const fetchBags = async () => {
      if (userId) {
        const [soonestUndeliveredBag, dietWithHighestId] = await Promise.all([
          get('/bags', {
            partial: true,
            itemsPerPage: 1,
            page: 1,
            'clientDiet.active': true,
            'order[date]': 'ASC',
            'date[strictly_after]': moment().format('YYYY-MM-DD'),
            'clientDiet.client.id': userId,
            'properties[clientDiet][]': 'id',
            'order[clientDiet.id]': 'DESC',
          }),
          get('ecommerce-diets', {
            partial: true,
            itemsPerPage: 1,
            page: 1,
            'client.id': userId,
            'order[id]': 'DESC',
          }),
        ]);

        setDietId(
          soonestUndeliveredBag['hydra:member'][0]?.clientDiet?.id ??
            dietWithHighestId['hydra:member'][0]?.id
        );
      }
    };

    fetchBags();
  }, [userId]);

  if (!dietId) {
    return <NoDietsCalendar userId={userId} />;
  }

  return <DietDetails dietId={dietId} setDietId={setDietId} />;
};

export default Calendar;
